/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvitationRenewalOutcome {
    SENT = 'SENT',
    SIGN_IN = 'SIGN_IN',
    INVITATION_PENDING = 'INVITATION_PENDING',
    CONTACT_INVITER = 'CONTACT_INVITER',
}
